module.exports = __webpack_public_path__ + "static/media/surge-sounds.1700430f.jpg";